import { TFunction } from 'i18next';
import * as yup from 'yup';

type LoginForm = {
  email: string;
  password: string;
};

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<LoginForm> =>
  yup
    .object({
      email: yup.string().email(t('form.validation.emailInvalid')).required(t('form.validation.emailInvalid')),
      password: yup.string().required(t('form.validation.fieldIsRequired')),
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;
